var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.551 0C178.551 0 166.754 37.8931 170.969 60.633C175.185 83.3729 185.713 120.008 182.347 130.959C179.72 139.494 176.443 145.274 137.257 143.167C96.5534 140.981 85.8554 144.854 72.3706 145.693C58.8858 146.531 2 152.85 2 127.585C2 120.008 11.2695 121.685 19.7 120.008C23.266 119.299 26.872 118.221 30.1882 116.754C44.8017 110.255 85.2261 93.5349 93.4369 90.111C103.545 85.8984 121.665 76.2155 120.826 56.0012C119.987 35.7868 116.611 9.68291 114.923 0",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.551 0C178.551 0 166.754 37.8931 170.969 60.633C175.185 83.3729 185.713 120.008 182.347 130.959C179.72 139.494 176.443 145.274 137.257 143.167C96.5534 140.981 85.8554 144.854 72.3706 145.693C58.8858 146.531 2 152.85 2 127.585C2 120.008 11.2695 121.685 19.7 120.008C23.266 119.299 26.872 118.221 30.1882 116.754C44.8017 110.255 85.2261 93.5349 93.4369 90.111C103.545 85.8984 121.665 76.2155 120.826 56.0012C119.987 35.7868 116.611 9.68291 114.923 0",
    stroke: "#4E555A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.697 80.1094C156.756 85.1205 157.615 89.383 157.805 90.8205C158.474 95.8316 154.129 101.502 151.002 103.618",
    stroke: "#4E555A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 91,
    x2: 1.25,
    y2: 174,
    stroke: "#2535E5",
    strokeWidth: 0.5,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.25,
    y1: 91,
    x2: 183.25,
    y2: 174,
    stroke: "#2535E5",
    strokeWidth: 0.5,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 165L7 167.887V162.113L2 165ZM182 165L177 162.113V167.887L182 165ZM6.5 165.5H177.5V164.5H6.5V165.5Z",
    fill: "#2535E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/Foot.2401b1760c8c8b619f15021e4d880c25.svg";
export { ForwardRef as ReactComponent };